import { API_PATH } from '../../routes/managePath';

export const ID_ISSUANCE_MANAGEMENT_PATH = {
  INDEX: API_PATH.ID_ISSUANCE_MANAGEMENT,
};
